import { render, staticRenderFns } from "./inputCompanion.vue?vue&type=template&id=aecf269a&scoped=true"
import script from "./inputCompanion.vue?vue&type=script&lang=js"
export * from "./inputCompanion.vue?vue&type=script&lang=js"
import style0 from "./inputCompanion.vue?vue&type=style&index=0&id=aecf269a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aecf269a",
  null
  
)

export default component.exports